module.exports = __webpack_public_path__ + "static/media/04_Maf_NuestroEquipo_MaDeLosAngelesMolina.c-01.d986356f.png";